module.exports = __webpack_public_path__ + "img/customer-img3.d1873fb0.png";